import React, { useState, useEffect } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
  CustomInput,
  Form,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';

export default function Drawer(props) {
  const { isVisible, toggleModal, currency } = props;
  const { rate, date, rateId, roomId, rateText, roomText } = props;

  const [oneRoom, setOneRoom] = useState([]);

  const [startDateRange, setStartDateRange] = useState(moment(date));
  const [endDateRange, setEndDateRange] = useState(null);

  const [rateType, setRateType] = useState('');
  const [numOfRooms, setNumOfRooms] = useState(1);
  const [adultsNum, setAdultsNum] = useState(1);
  const [childrenNum, setChildrenNum] = useState(0);

  const [guest, setGuest] = useState({
    email: '',
    first_name: '',
    last_name: '',
    telephone: '',
  });

  //  TODO: now I do not need this val.
  const [room, setRoom] = useState({
    rateType: '',
    adultsNum: '',
    childrenNum: '',
    numOfRooms: '',
  });

  const [price, setPrice] = useState(null);
  const [reservation, setReservation] = useState({
    propertyid: '',
    customer: {
      email: 'abc@test.com',
      first_name: 'Test',
      last_name: 'STAAH',
      telephone: '+12121212',
    },
  });

  useEffect(() => {
    setReservation(preReservation => {
      return {
        ...preReservation,
        customer: {
          ...preReservation.customer,
          first_name: guest.first_name,
          last_name: guest.last_name,
          email: guest.email,
          telephone: guest.telephone,
        },
      };
    });
  }, [guest]);

  const handleClickSubmit = () => {
    console.log('reservation is', reservation);
  };

  const handleChangeStart = date => {
    setStartDateRange(date);
  };

  const handleChangeEnd = date => {
    setEndDateRange(date);
  };

  const handleChangeRateType = e => {
    e.preventDefault();
    //console.log('value', e.target.value);
    setRateType(e.target.value);
  };
  const handleChangeNumOfRooms = e => {
    setNumOfRooms(e.target.value);
  };

  const handleChangeAdults = e => {
    setAdultsNum(e.target.value);
  };

  const handleChangeChildren = e => {
    setChildrenNum(e.target.value);
  };

  const handleChangeGuestFirstName = e => {
    const val = e.target.value;
    if (val) {
      setGuest(pre => {
        return { ...pre, first_name: val };
      });
    }
  };

  const handleChangeGuestLastName = e => {
    const val = e.target.value;
    if (val) {
      setGuest(pre => {
        return { ...pre, last_name: val };
      });
    }
  };
  const handleChangeGuestEmail = e => {
    const val = e.target.value;
    if (val) {
      setGuest(pre => {
        return { ...pre, email: val };
      });
    }
  };
  const handleChangeGuestPhone = e => {
    const val = e.target.value;
    if (val) {
      setGuest(pre => {
        return { ...pre, telephone: val };
      });
    }
  };

  return (
    <div>
      <Modal
        size="lg"
        isOpen={isVisible}
        toggle={toggleModal}
      // wrapClassName="modal-right"
      >
        <ModalHeader toggle={toggleModal}>Booking</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Colxx sm={8}>
                <h2>Room/s</h2>
              </Colxx>
              <Colxx sm={4}>
                {price ? (
                  <h2>Total: {currency} {price !== undefined ? price.toLocaleString() : ''}</h2>
                ) : (
                  <h2>Total: {currency} {rate !== undefined ? rate.toLocaleString() : ''}</h2>
                )}
              </Colxx>
              <Colxx sm={12}>
                <Label>Travel Dates</Label>
                <Row>
                  <Colxx sm="6">
                    <DatePicker
                      selected={startDateRange}
                      selectsStart
                      startDate={startDateRange}
                      endDate={endDateRange}
                      onChange={handleChangeStart}
                      placeholderText="Check In"
                    />
                  </Colxx>
                  <Colxx sm="6">
                    <DatePicker
                      selected={endDateRange}
                      selectsEnd
                      startDate={startDateRange}
                      endDate={endDateRange}
                      onChange={handleChangeEnd}
                      placeholderText="Check Out"
                    />
                  </Colxx>
                </Row>
              </Colxx>
              <Colxx sm={12}>
                <FormGroup>
                  <Row style={{ marginTop: '20px' }}>
                    <Colxx sm={6}>
                      <FormGroup>
                        <Label><IntlMessages id='dashboards.room-type' /></Label>
                        <Input className='input_sty' disabled placeholder={roomText}></Input>
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={3}>
                      <FormGroup>
                        <Label>Rate Type</Label>
                        <Input className='input_sty'
                          type="select"
                          value={rateType}
                          onChange={handleChangeRateType}
                        >
                          {/* FIXME: */}
                          {rateText === 'Basic Rate' ? (
                            <option value={1}>{rateText}</option>
                          ) : null}
                          {rateText === 'Basic With Breakfast' ? (
                            <option value={2}>{rateText}</option>
                          ) : null}
                          {rateText === 'Non-Refundable' ? (
                            <option value={3}>{rateText}</option>
                          ) : null}
                          {/* <option>{rateText}</option> */}
                          <option value={1}>Basic Rate</option>
                          <option value={2}>Basic With Breakfast</option>
                          <option value={3}>Non-Refundable</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <FormGroup>
                        <Label><IntlMessages id='dashboards.number-of-rooms-this-type' /></Label>
                        <Input className='input_sty'
                          name="number of rooms"
                          type="select"
                          onChange={handleChangeNumOfRooms}
                          defaultValue={numOfRooms}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                  </Row>
                </FormGroup>
              </Colxx>

              <Colxx sm={12}>
                <FormGroup>
                  <Row style={{ marginTop: '-10px' }}>
                    <Colxx sm={3}>
                      <FormGroup>
                        <Label>Adults</Label>
                        <Input className='input_sty'
                          name="adults"
                          type="select"
                          onChange={handleChangeAdults}
                          defaultValue={adultsNum}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <FormGroup>
                        <Label>Children</Label>
                        <Input className='input_sty'
                          name="children"
                          type="select"
                          onChange={handleChangeChildren}
                          defaultValue={childrenNum}
                        >
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                  </Row>
                </FormGroup>
              </Colxx>

              {/* Guests Info */}
              <Colxx sm={12}>
                <h2>Guest Information</h2>
              </Colxx>
              <Colxx sm={6}>
                <FormGroup>
                  <Label>First Name</Label>
                  <Input className='input_sty'
                    type="text"
                    name="first-name"
                    placeholder="ChangeMe"
                    onChange={handleChangeGuestFirstName}
                  // value={guest.first_name}
                  />
                </FormGroup>
              </Colxx>

              <Colxx sm={6}>
                <FormGroup>
                  <Label>Last Name</Label>
                  <Input className='input_sty'
                    type="text"
                    name="last-name"
                    placeholder="ChangeMe"
                    onChange={handleChangeGuestLastName}
                    value={guest.last_name}
                  />
                </FormGroup>
              </Colxx>

              <Colxx sm={6}>
                <FormGroup>
                  <Label>Phone Number</Label>
                  <Input className='input_sty'
                    type="text"
                    name="phone-number"
                    placeholder="ChangeMe"
                    onChange={handleChangeGuestPhone}
                    value={guest.telephone}
                  />
                </FormGroup>
              </Colxx>

              <Colxx sm={6}>
                <FormGroup>
                  <Label>Email</Label>
                  <Input className='input_sty'
                    type="text"
                    name="email"
                    placeholder="ChangeMe"
                    onChange={handleChangeGuestEmail}
                    value={guest.email}
                  />
                </FormGroup>
              </Colxx>

              <Colxx sm={12}>
                <h2>Payment</h2>
              </Colxx>

              <Colxx sm={12}>
                <FormGroup>
                  <div>
                    <CustomInput
                      type="radio"
                      id="exCustomRadio"
                      name="customRadio"
                      label="Email payment requst"
                    />
                    <CustomInput
                      type="radio"
                      id="exCustomRadio2"
                      name="customRadio"
                      label="Book without payment"
                    />
                  </div>
                </FormGroup>
              </Colxx>

              <Colxx sm={12}>
                <FormGroup>
                  <Label>Special Requests</Label>
                  <div>
                    <Input className='input_sty' type="text" />
                  </div>
                </FormGroup>
              </Colxx>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" onClick={handleClickSubmit}>
            Book Now
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
